import { IRankingExtendedSearch, IRankingsData } from "src/api/server/extended-search.types";
import { getVisibleRankings } from "src/components/pages/search/components/rankings-dropdown-selector/utils/get-visible-rankings";
import { ISelectedRanking } from "../components/types";

interface IGetResetSelectedRankingParams {
    rankingsData: IRankingsData;
    selectedFigures: ReadonlyArray<string>;
    currentSelectedRanking: ISelectedRanking;
}

const isRankingVisible = (ranking: IRankingExtendedSearch, rankingsData: IRankingsData, selectedFigures: ReadonlyArray<string>): boolean => {
    if (ranking.id === null) {
        return false;
    }

    const visibleRankings = getVisibleRankings(rankingsData.rankings, rankingsData.relevanceRanking, selectedFigures);
    return visibleRankings.some(visibleRanking => visibleRanking.id === ranking.id);
};

export const getResetSelectedRanking = ({
    rankingsData,
    selectedFigures,
    currentSelectedRanking,
}: IGetResetSelectedRankingParams): ISelectedRanking => {
    const isPlaceholderSelected = currentSelectedRanking.id === null;
    if (!isPlaceholderSelected) {
        return currentSelectedRanking;
    }

    const { defaultSelectedRanking } = rankingsData;
    if (!isRankingVisible(defaultSelectedRanking, rankingsData, selectedFigures)) {
        return currentSelectedRanking;
    }

    return { id: defaultSelectedRanking.id, sortDirection: defaultSelectedRanking.sortDirection };
};
